/** @jsx jsx */

import { useCallback } from 'react';

import { jsx, css } from '@emotion/core';
import { Select, SelectItem } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants/url';

import type { TriggerSchema } from 'app/developer-v3/platformSchema/trigger';

const Styles = {
  // Temporary styles to conform to Platform's Formatic forms since this is not
  // a plugin of Formatic.
  title: css`
    &:: after {
      content: '(required)';
      color: rgb(255, 74, 0);
      font-size: 11px;
      margin: 0 6px;
    }
    color: #354147;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;
  `,
};

type Props = {
  onChange: (triggerKey: string) => void;
  triggerKey?: string;
  triggers: TriggerSchema[];
};

function TestTrigger(props: Props) {
  const { onChange, triggerKey, triggers } = props;

  const mapTriggerToItem = useCallback(
    trigger => ({
      label: trigger?.display?.label,
      value: trigger?.key,
    }),
    []
  );

  const items = triggers.map(mapTriggerToItem);

  return (
    <div>
      <div css={Styles.title}>Test Trigger</div>
      <p>
        Select the test trigger we'll use to verify a user's auth credentials. A
        good test trigger returns a 200 on success or a 300+ on failure.{' '}
        <Link
          href={`${BASE_DOC_URL_VB}/manage/versions-legacy`}
          target="_blank"
        >
          Read more
        </Link>
        .
      </p>
      <Select
        label="Test Trigger"
        isLabelHidden
        selectedKey={triggerKey ?? null}
        onChange={key => onChange(key as string)}
        placeholder="Choose a test trigger"
      >
        {items.map(item => (
          <SelectItem key={item.value} value={item.value}>
            {item.label}
          </SelectItem>
        ))}
      </Select>
    </div>
  );
}

export default TestTrigger;
